import { render, staticRenderFns } from "./choose-sn.vue?vue&type=template&id=04bd0508&"
import script from "./choose-sn.vue?vue&type=script&lang=js&"
export * from "./choose-sn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports